// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","bookmark":"bookmark-module__bookmark___1S6_v"};